import React from 'react'
import PropTypes from 'prop-types'

import { Avatar, Box, Text } from '@maui/elements'
import { formatLongDate, stripHtml } from '../../../../../utilities'

export default function Comment({ comment }) {
  const { author, body, created_at: date } = comment
  const avatarStr = (author.includes('Mandiant') || author.includes('MA')) ? 'M' : author
  const safeComment = stripHtml(body)

  return (
    <Box marginBottom='spaceGapSmall' color='colorTextMain'>
      <Box display='flex'>
        <Box width='30px'>
          <Avatar
            color='colorTextMain'
            backgroundColor='colorFillMain'
            fontSize='12px'
            size='24px'
            marginTop='1px'
          >
            {avatarStr}
          </Avatar>
        </Box>
        <Box flex='1' paddingTop='spaceGapSmall'>
          <Box marginBottom='spaceGapMedium'>
            <Text as='span' variant='body2' fontWeight='bold'>{author}</Text>
            <Text as='span' variant='body2' paddingLeft='spaceGapSmall' paddingRight='spaceGapSmall'> - </Text>
            <Text as='span' variant='body2' color='colorTextDeemphasis'>{formatLongDate(date)}</Text>
          </Box>
          <Text variant='body2' color='colorTextMain'>{safeComment}</Text>
        </Box>
      </Box>
    </Box>
  )
}

Comment.propTypes = {
  comment: PropTypes.shape({
    author: PropTypes.string,
    body: PropTypes.string,
    created_at: PropTypes.string,
  }),
}
